// src/components/Auth/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken, isSessionExpired, clearAuthSession } from '../../api/authSession';

const ProtectedRoute = ({ children }) => {
    const token = getAuthToken();
    const expired = isSessionExpired();
    
    if (!token || expired) {
        if (expired && token) {
            clearAuthSession();
        }
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;